module.exports = __webpack_public_path__ + "static/media/onda-violeta-3.a4c610d0.png";